import WebIM from '../../utils/WebIM'
import store from '../../redux/store'
import { setMyUserInfo, setFetchingStatus } from '../../redux/actions'
import { message } from '../../components/common/alert'
import i18next from "i18next";
import { createHashHistory } from 'history'
import { reject } from 'lodash';
import axios from 'axios'

const history = createHashHistory()
export const getToken = (agoraId, password) => {
    return postData(process.env.REACT_APP_CHAT_USER_LOGIN_URL, { "userAccount": agoraId, "userPassword": password })
}
export const signUp = (agoraId, password) => {
    return postData(process.env.REACT_APP_CHAT_USER_REGISTER_URL, { "userAccount": agoraId, "userPassword": password })
}

export const loginWithToken = (agoraId, agoraToken) => {
    let options = {
        user: agoraId,
        agoraToken: agoraToken
    };

    return new Promise((resolve,reject) => {
        WebIM.conn.open(options).then(res => {
            WebIM.conn.fetchUserInfoById(agoraId).then(val => {
                const res = val.data || {}
                store.dispatch(setMyUserInfo({ nickName: res[agoraId]?.nickname || '' }))
            })
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

export function postData(url, data) {
    return fetch(url, {
        body: JSON.stringify(data),
        cache: 'no-cache',
        headers: {
            'content-type': 'application/json'
        },
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        referrer: 'no-referrer',
    })
        .then(response => response.json())
}

// Logs in directly against Agora with the user's chat password (no app/token server needed).
// The caller is responsible for writing `webim_auth` to sessionStorage before calling this,
// because the onConnected listener reads group_id from it.
export const loginWithPassword = (agoraId, password) => {
    let options = {
        user: agoraId,
        pwd: password
    };

    return WebIM.conn.open(options).then((res) => {
        store.dispatch(setMyUserInfo({ agoraId, password }))
        WebIM.conn.fetchUserInfoById(agoraId).then(val => {
            const data = val.data || {}
            store.dispatch(setMyUserInfo({ nickName: data[agoraId]?.nickname || '' }))
        })
        return res
    }).catch((err) => {
        store.dispatch(setFetchingStatus(false))
        throw err
    })
}


export function logout() {
    WebIM.conn.close()
    sessionStorage.removeItem('webim_auth')
    window.document.title = 'Muafa Chat'
    window.location.href = 'https://muafa.sa/doctor/'
}

export function register (agoraId, password, nickname) {
    let options = {
        // appKey: WebIM.config.appkey,
        // apiUrl: WebIM.config.restServer,
        username: agoraId,
        password: password,
        nickname: nickname ? nickname.trim().toLowerCase() : '',
        success: function(){
            store.dispatch(setFetchingStatus(false))
            store.dispatch(setMyUserInfo({ agoraId, password }))
            sessionStorage.setItem('webim_auth', JSON.stringify({ agoraId, password }))
            history.push('/login')
        },

        error: (err) => {
            store.dispatch(setFetchingStatus(false))
            if (JSON.parse(err.data).error === 'duplicate_unique_property_exists') {
                message.error(i18next.t('UserAlreadyExists'))
            } else if (JSON.parse(err.data).error === 'illegal_argument') {
                if (JSON.parse(err.data).error_description === 'USERNAME_TOO_LONG') {
                    return message.error(i18next.t('UserNameTooLong'))
                }else if(JSON.parse(err.data).error_description === 'password or pin must provided'){
                    return  message.error(i18next.t('InvalidPassword'))
                }
                message.error(i18next.t('InvalidUserName'))
            } else if (JSON.parse(err.data).error === 'unauthorized') {
                message.error(i18next.t('SignUpFailed'))
            } else if (JSON.parse(err.data).error === 'resource_limited') {
                message.error(i18next.t('LimitAccount'))
            }
        }
    }
    WebIM.conn.registerUser(options)
}
